import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import { Observable } from "rxjs/Observable";
import { Injectable } from '@angular/core';

import { CuestionarioService } from "../_services/cuestionario.service";

import { AppSettings } from '../_models/settings.models'
import { SeguridadService } from '../_services/seguridad.service'

@Injectable()
export class GlobalEventsManager {

    private _showNavBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    public showNavBarEmitter: Observable<boolean> = this._showNavBar.asObservable();

    private _nombreUsuario: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    public nombreUsuarioEmitter: Observable<string> = this._nombreUsuario.asObservable();

    private _nombrePagina: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public nombrePaginaEmitter: Observable<any> = this._nombrePagina.asObservable();

    private _menuExtendido: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    public menuExtendidoEmitter: Observable<boolean> = this._menuExtendido.asObservable();

    private _mostrarError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    public mostrarErrorEmitter: Observable<boolean> = this._mostrarError.asObservable();

    private _objError: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public objErrorEmitter: Observable<any> = this._objError.asObservable();

    private _evidenciasSinRelacionar: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public evidenciasSinRelacionarEmitter: Observable<any> = this._evidenciasSinRelacionar.asObservable();

    private _evidenciasSinRelacionarCuestionario: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public evidenciasSinRelacionarCuestionarioEmitter: Observable<any> = this._evidenciasSinRelacionarCuestionario.asObservable();

    private _alert: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public alertEmitter: Observable<any> = this._alert.asObservable();

    private _pilaevidencias: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public pilaEvidenciasEmitter: Observable<any> = this._pilaevidencias.asObservable();

    constructor(private http: Http) {}

    showNavBar(ifShow: boolean) {
      this._showNavBar.next(ifShow);
    }

    getNombreUsuario(){
      let nombre = localStorage.getItem('currentUserName');
      if (nombre){
        this._nombreUsuario.next(localStorage.getItem('currentUserName'));
      }else{
        this._nombreUsuario.next("");
      }
    }

    getEvidenciasSinRelacionarService(id_cuestionario: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionarioEvidenciasSinRelacionar", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              return response;

          });

    }

    getEvidenciasSinRelacionarCuestionarioService(id_cuestionario: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, nivelmodulo: "0", tokenid: userToken, action: "CuestionarioEvidenciasSinRelacionar", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              return response;

          });

    }

    getEvidenciasSinRelacionar(id_cuestionario: number) {
      this.getEvidenciasSinRelacionarService(id_cuestionario).subscribe(
        data => {
          if (data){

            this._evidenciasSinRelacionar.next(data.json().evidencias);

          }
        }
      );
    }

    getEvidenciasSinRelacionarCuestionario(id_cuestionario: number) {

      this.getEvidenciasSinRelacionarCuestionarioService(id_cuestionario).subscribe(
        data => {
          if (data){

            this._evidenciasSinRelacionarCuestionario.next(data.json().evidencias);

          }
        }
      );
    }

    menuExtendido(extendido: boolean){
      this._menuExtendido.next(extendido);
    }

    mostrarError(mostrar: boolean){
      this._mostrarError.next(mostrar);
    }

    objError(errormsg: any){
      this._objError.next(errormsg);
    }

    setNombrePagina(params: any){
      this._nombrePagina.next(params);
    }

    setAlert(params: any){
      this._alert.next(params);
    }

    setPilaEvidencias(params: any){
      this._pilaevidencias.next(params);
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/globaleventsmanager.service.ts